import { Component, Input, OnChanges, ViewChild } from '@angular/core';
import { MatSort, MatSortHeader, Sort } from '@angular/material/sort';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable,
  MatTableDataSource,
} from '@angular/material/table';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { SiteDto, StoreDto } from '@dto';
import { getSiteBessStatus, getSiteColor } from '@helpers';

@Component({
  imports: [
    MatTable,
    MatSort,
    MatHeaderCell,
    MatColumnDef,
    MatHeaderCellDef,
    TranslatePipe,
    MatSortHeader,
    MatCell,
    MatCellDef,
    MatHeaderRow,
    MatHeaderRowDef,
    MatRow,
    MatRowDef,
  ],
  selector: 'monitor-ui-site-table',
  styleUrls: ['./site-table.component.scss'],
  templateUrl: './site-table.component.html',
})
export class SiteTableComponent implements OnChanges {
  dataSource: MatTableDataSource<SiteDto>;
  displayedColumns = ['available', 'displayLabel', 'controlMode', 'bessStatus', 'soc', 'sitePower', 'bessPower'];
  @Input() sites: SiteDto[];
  @ViewChild(MatSort) sort: MatSort;

  protected readonly getSiteBessStatus = getSiteBessStatus;
  protected readonly getSiteColor = getSiteColor;

  constructor(private router: Router) {}

  async navigateToSite(id: string): Promise<void> {
    await this.router.navigateByUrl(`/details/${id}/view-site`);
  }

  ngOnChanges(): void {
    this.sites = this.sites.sort((firstDate: SiteDto, secondDate: SiteDto) => {
      return new Date(secondDate.lastUpdatedDate).valueOf() - new Date(firstDate.lastUpdatedDate).valueOf();
    });
    this.initDataSource(this.sites);
  }

  sortData(sort: Sort): void {
    const data = this.sites.slice();
    if (!sort.active || sort.direction === '') {
      this.initDataSource(this.sites);
      return;
    }

    this.initDataSource(data);
  }

  storesPower(stores: StoreDto[]): number {
    return stores?.map(s => s.power ?? 0).reduce((sum, x) => sum + x, 0) ?? 0;
  }

  private initDataSource(sites: SiteDto[]): void {
    if (!sites?.length) {
      return;
    }
    const initTable = (): void => {
      this.dataSource = new MatTableDataSource<SiteDto>(sites);
      this.dataSource.sort = this.sort;
    };
    setTimeout(initTable);
  }
}
